/**
 * Bravik Slide-Out Cart Drawer Controller
 * Native Shopify AJAX Cart API Integration
 */

class BravikCartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer-wrapper');
    this.backdrop = document.querySelector('.cart-drawer-backdrop');
    this.itemsContainer = document.querySelector('.cart-drawer-items');
    this.subtotalEl = document.querySelector('.cart-subtotal-val');
    this.cartCountBadges = document.querySelectorAll('.cart-count-bubble');
    this.emptyState = document.querySelector('.cart-empty-state');
    this.filledState = document.querySelector('.cart-filled-state');

    this.initEvents();
  }

  initEvents() {
    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    document.querySelectorAll('[data-close-cart]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }

    if (this.itemsContainer) {
      this.itemsContainer.addEventListener('click', (e) => {
        const qtyBtn = e.target.closest('[data-qty-change]');
        const removeBtn = e.target.closest('[data-cart-remove]');

        if (qtyBtn) {
          e.preventDefault();
          const line = qtyBtn.dataset.line;
          const currentQty = parseInt(qtyBtn.dataset.currentQty, 10);
          const change = parseInt(qtyBtn.dataset.qtyChange, 10);
          const newQty = currentQty + change;
          this.updateQuantity(line, newQty);
        }

        if (removeBtn) {
          e.preventDefault();
          const line = removeBtn.dataset.line;
          this.updateQuantity(line, 0);
        }
      });
    }
  }

  open() {
    if (!this.drawer) return;
    this.refresh();
    this.drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async refresh() {
    try {
      const response = await fetch(window.Bravik.routes.cart_url + '.js');
      const cart = await response.json();
      this.renderCart(cart);
    } catch (err) {
      console.error('Error refreshing cart:', err);
    }
  }

  async updateQuantity(line, quantity) {
    try {
      const response = await fetch(window.Bravik.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await response.json();
      this.renderCart(cart);
    } catch (err) {
      console.error('Error updating line item quantity:', err);
    }
  }

  renderCart(cart) {
    this.cartCountBadges.forEach(badge => {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (cart.item_count === 0) {
      if (this.emptyState) this.emptyState.style.display = 'block';
      if (this.filledState) this.filledState.style.display = 'none';
      if (this.itemsContainer) this.itemsContainer.innerHTML = '';
      return;
    }

    if (this.emptyState) this.emptyState.style.display = 'none';
    if (this.filledState) this.filledState.style.display = 'flex';

    if (this.itemsContainer) {
      this.itemsContainer.innerHTML = cart.items.map((item, index) => {
        const line = index + 1;
        const formattedPrice = window.Bravik.formatMoney(item.final_line_price);
        const options = item.options_with_values ? item.options_with_values.map(opt => `${opt.name}: ${opt.value}`).join(' • ') : item.variant_title;

        return `
          <div class="cart-item-row" data-line="${line}">
            <div class="cart-item-img-wrapper">
              <img src="${item.featured_image.url}&width=140" alt="${item.title}" class="cart-item-img" width="70" height="90" loading="lazy">
            </div>
            <div class="cart-item-details">
              <h4 class="cart-item-title">${item.product_title}</h4>
              <p class="cart-item-variant">${options || ''}</p>
              <div class="price">${formattedPrice}</div>
              <div class="cart-item-qty-row">
                <div class="qty-control">
                  <button type="button" class="qty-btn" data-qty-change="-1" data-current-qty="${item.quantity}" data-line="${line}" aria-label="Decrease quantity">&minus;</button>
                  <span class="qty-input">${item.quantity}</span>
                  <button type="button" class="qty-btn" data-qty-change="1" data-current-qty="${item.quantity}" data-line="${line}" aria-label="Increase quantity">&plus;</button>
                </div>
                <button type="button" class="cart-item-remove-btn" data-cart-remove data-line="${line}">Remove</button>
              </div>
            </div>
          </div>
        `;
      }).join('');
    }

    if (this.subtotalEl) {
      this.subtotalEl.textContent = window.Bravik.formatMoney(cart.total_price);
    }

    /* Free shipping progress (threshold: EGP 1,000 = 100000 cents) */
    var prog = document.querySelector('[data-shipping-progress]');
    if (prog) {
      var threshold = parseInt(prog.dataset.thresholdCents, 10) || 100000;
      var msg = prog.querySelector('[data-shipping-msg]');
      var fill = prog.querySelector('[data-shipping-fill]');
      var remaining = threshold - cart.total_price;
      if (remaining > 0) {
        if (msg) msg.innerHTML = 'Add ' + window.Bravik.formatMoney(remaining) + ' more to unlock <strong>FREE SHIPPING</strong> 🚚';
        if (fill) fill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
        if (fill) fill.classList.remove('is-unlocked');
      } else {
        if (msg) msg.innerHTML = '🎉 You have unlocked <strong>FREE SHIPPING</strong>!';
        if (fill) fill.style.width = '100%';
        if (fill) fill.classList.add('is-unlocked');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BravikCart = new BravikCartDrawer();
});

